import { render, staticRenderFns } from "./OrderGotPriority.vue?vue&type=template&id=14ad4b13&"
import script from "./OrderGotPriority.vue?vue&type=script&lang=js&"
export * from "./OrderGotPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports